import * as React from "react"
const More = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M8.894 19.238a2.695 2.695 0 0 0-2.687 2.687 2.695 2.695 0 0 0 2.687 2.688 2.695 2.695 0 0 0 2.688-2.688 2.695 2.695 0 0 0-2.688-2.687Zm26.875 0a2.695 2.695 0 0 0-2.687 2.687 2.695 2.695 0 0 0 2.687 2.688 2.695 2.695 0 0 0 2.688-2.688 2.695 2.695 0 0 0-2.688-2.687Zm-13.437 0a2.695 2.695 0 0 0-2.688 2.687 2.695 2.695 0 0 0 2.688 2.688 2.695 2.695 0 0 0 2.687-2.688 2.695 2.695 0 0 0-2.687-2.687Z"
    />
  </svg>
)
export default More